import React from 'react'
import first from '../Images/service1.png';
import second from '../Images/msg-modified.png';
import third from '../Images/Hammam-modified.png';
import fourth from '../Images/bodycare-modified.png';
import fifth from '../Images/laser-modified.png';
import sixth from '../Images/beard-modified.png';

export default function Services() {
    return (
        <div id="services"><br />
            <h1>خدمات</h1>
            <p>نقدم باقات مخصصة تشمل جلسات عناية بالبشرة المتقدمة، التدليك الاسترخائي، وخدمات الحلاقة، لنساعدك على الاستمتاع بتجربة فريدة تعزز من جمالك الطبيعي ويرفع من مستوى الراحة العامة</p>

            <div className="card">
                <br />
                <img src={second} alt="pic" className="card-img-top" />
                <div className="card-body">
                    <h2 className="card-title">تدليك استرخائي</h2>
                    <p className="text">استمتع بجلسة تدليك عميقة تساعد في تخفيف التوتر وتجديد النشاط الجسدي والذهني.</p>
                </div>
            </div>

            <div className="card">
                <br />
                <img src={third} alt="pic" className="card-img-top" />
                <div className="card-body">
                    <h2 className="card-title">حمام مغربي</h2>
                    <p className="text">تجربة تنظيف وترطيب عميقة للبشرة باستخدام تقنيات الحمام المغربي التقليدية.</p>
                </div>
            </div>
            
            <div className="card">
                <br />
                <img src={fourth} alt="pic" className="card-img-top" />
                <div className="card-body">
                    <h2 className="card-title">بديكير رجول ويدين</h2>
                    <p className="text">حافظ على جمال ونظافة أقدامك ويديك من خلال جلسات البديكير المتخصصة.</p>
                </div>
            </div>
            
            <div className="card">
                <br />
                <img src={fifth} alt="pic" className="card-img-top" />
                <div className="card-body">
                    <h2 className="card-title">تنظيف البشرة بالليزر</h2>
                    <p className="text">تقنية حديثة لتنظيف عميق للبشرة، تعمل على إزالة الشوائب وتحسين ملمس البشرة.</p>
                </div>
            </div>
            
            <div className="card">
                <br />
                <img src={first} alt="pic" className="card-img-top" />
                <div className="card-body">
                    <h2 className="card-title">قصة شعر أنيقة</h2>
                    <p className="text">احصل على مظهر جديد وعصري مع قصة شعر تناسب شخصيتك وأسلوبك.</p>
                </div>
            </div>
            
            <div className="card">
                <br />
                <img src={sixth} alt="pic" className="card-img-top" />
                <div className="card-body">
                    <h2 className="card-title">حلاقة دقن</h2>
                    <p className="text">حلاقة دقيقة وتنظيف شامل للدقن لتحصل على مظهر أنيق ومتميز.</p>
                </div>
            </div>
            <br /><br /><br /><br /><br /><br />
        </div>
    )
}


